import { max } from "sites-common/utils/lodash";
import {
  patientsSittingsSelectors,
  patientsSittingsConfig,
  queryPatientsSittings,
  postprocessPatientsSittings,
  validatePatientsSittings,
} from "../../common1/firebase-selectors/patients-sittings";
import renderSingleItemForm from "./renderSingleItemForm";
import { savePatients } from "../../common1/firebase-selectors/patients";

const ConfigSingle = (patient) => {
  const pSelectors = patientsSittingsSelectors(patient);

  return {
    primaryKey: patientsSittingsConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryPatientsSittings(patient)],

    sessionKey: `careapp.patients.sitting${patient}`,
    noItemMsg: "No Sittings Available",
    mainTitle: "Sittings ",

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: patientsSittingsConfig.collection(patient),
    postprocess: postprocessPatientsSittings,
    validate: validatePatientsSittings,
    formFields: patientsSittingsConfig.fields,
    formDefaults: patientsSittingsConfig.defaults,

    postSave: ({ dbStore }) => {
      dbStore
        .get(patientsSittingsConfig.collection(patient), "sittings")
        .then((doc) => {
          if (doc.exists) {
            const last_sitting_date = max(
              doc.data().sittings.map((r) => r.date)
            );
            savePatients(dbStore, patient, { last_sitting_date });
          }
        });
    },

    renderSingleItemForm,
  };
};

export default ConfigSingle;
